export default "__VITE_ASSET__BEM1IjUQ__"